(function () {
  'use strict';

  var config = window.BOLLIDE_STICKY_ATC_PRODUCT || {};
  var variants = Array.isArray(config.variants) ? config.variants : [];
  if (!variants.length) return;

  var CTA_TEXT = 'Add to Bag';
  var COMING_SOON_TEXT = 'Coming soon';
  var FIT_NOTE_TEXT = normalize(config.fitNote);
  var cottonOrder = ['Denim Blue', 'Black', 'Khaki', 'Light Wash Denim', 'Ivory Cotton Twill', 'Black Cotton Twill'];
  var sportOrder = ['Black Performance Twill', 'White Performance Twill'];
  var rowOrder = [
    { key: 'cotton', label: 'Cotton twill', order: cottonOrder },
    { key: 'suede', label: 'Performance suede', order: [] },
    { key: 'sport', label: 'Performance twill', order: sportOrder }
  ];

  var swatchColors = {
    alabaster: '#E8DECA',
    forest: '#756519',
    noir: '#000000',
    midnight: '#1D3057',
    charcoal: '#44403C',
    espresso: '#4B301F',
    merlot: '#4A121B',
    camel: '#A97A4C',
    'rose pink': '#C08A8C',
    'denim blue': '#8FA6B4',
    'black': '#171717',
    'khaki': '#A89B78',
    'light wash denim': '#A9BBCD',
    'ivory cotton twill': '#F4EFE1',
    'black cotton twill': '#050609',
    'black performance twill': '#050609',
    'white performance twill': '#FFFFFF'
  };

  function normalize(value) {
    return String(value || '')
      .replace(/^selected\s*color\s*:?\s*/i, '')
      .replace(/^color\s*:?\s*/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function key(value) {
    return normalize(value).toLowerCase();
  }

  function includesName(list, value) {
    var target = key(value);
    return list.some(function (name) { return key(name) === target; });
  }

  function colorOptionIndex() {
    if (typeof config.colorOptionIndex === 'number') return config.colorOptionIndex;
    var options = Array.isArray(config.options) ? config.options : [];
    for (var i = 0; i < options.length; i += 1) {
      if (/color|colour/i.test(String(options[i] || ''))) return i;
    }
    return 0;
  }

  function colorFromVariant(variant) {
    if (!variant) return '';
    var options = [variant.option1, variant.option2, variant.option3];
    return normalize(options[colorOptionIndex()] || variant.option1 || variant.title);
  }

  function groupForColor(color) {
    if (includesName(cottonOrder, color)) return 'cotton';
    if (includesName(sportOrder, color)) return 'sport';
    return 'suede';
  }

  function materialLabel(color) {
    var group = groupForColor(color);
    var row = rowOrder.find(function (rowDef) { return rowDef.key === group; });
    return row ? row.label : 'Material';
  }

  function displayColor(color) {
    return normalize(color)
      .replace(/\s+Cotton\s+Twill$/i, '')
      .replace(/\s+Performance\s+Twill$/i, '');
  }

  function shouldShowFitNote() {
    var title = String(config.productTitle || document.title || '').toLowerCase();
    return title.indexOf('hat') !== -1 || title.indexOf('cap') !== -1;
  }

  function variantById(id) {
    if (!id) return null;
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function variantByColor(color) {
    var target = key(color);
    var matches = variants.filter(function (variant) {
      return key(colorFromVariant(variant)) === target;
    });
    return matches.find(function (variant) { return variant.available; }) || matches[0] || null;
  }

  function orderedColors(colors, preferredOrder) {
    var lookup = {};
    var used = {};
    var output = [];

    colors.forEach(function (color) { lookup[key(color)] = color; });
    preferredOrder.forEach(function (name) {
      var color = lookup[key(name)];
      if (color && !used[key(color)]) {
        output.push(color);
        used[key(color)] = true;
      }
    });
    colors.forEach(function (color) {
      if (!used[key(color)]) output.push(color);
    });

    return output;
  }

  function groupedColors() {
    var groups = { cotton: [], suede: [], sport: [] };
    var seen = {};

    variants.forEach(function (variant) {
      var color = colorFromVariant(variant);
      var colorKey = key(color);
      if (/^classic\s+/i.test(color)) return;
      if (/\/products\/the-silk-lined-hat(?:\/|$)/.test(window.location.pathname) && (/^oxblood$/i.test(color) || (/^(camel|rose pink)$/i.test(color) && !variant.available))) return;
      if (!color || seen[colorKey]) return;
      seen[colorKey] = true;
      groups[groupForColor(color)].push(color);
    });

    groups.cotton = orderedColors(groups.cotton, cottonOrder);
    groups.sport = orderedColors(groups.sport, sportOrder);
    return groups;
  }

  function injectStyles() {
    var existing = document.getElementById('bollide-sticky-atc-grouped-swatches-css');
    if (existing) return;

    var style = document.createElement('style');
    style.id = 'bollide-sticky-atc-grouped-swatches-css';
    style.textContent = [
      'html body #sticky-atc{top:auto!important;bottom:0!important;left:0!important;right:0!important;width:100%!important;background:rgba(255,255,255,.94)!important;border-top:1px solid rgba(5,6,9,.08)!important;box-shadow:0 -18px 50px rgba(5,6,9,.07)!important;backdrop-filter:saturate(180%) blur(18px);-webkit-backdrop-filter:saturate(180%) blur(18px);}',
      'html body #sticky-atc .sticky-atc-inner{max-width:1320px!important;min-height:84px!important;margin:0 auto!important;padding:10px 32px!important;display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:28px!important;}',
      'html body #sticky-atc .sticky-atc-left{display:grid!important;grid-template-columns:54px minmax(0,1fr)!important;align-items:center!important;gap:16px!important;min-width:0!important;}',
      'html body #sticky-atc .sticky-atc-left img{width:54px!important;height:54px!important;object-fit:cover!important;border-radius:8px!important;background:#f7f6f2!important;box-shadow:inset 0 0 0 1px rgba(5,6,9,.06)!important;}',
      'html body #sticky-atc .sticky-atc-left>div{display:grid!important;grid-template-columns:minmax(170px,240px) minmax(180px,1fr) auto!important;grid-template-areas:"title variants price"!important;align-items:center!important;column-gap:22px!important;min-width:0!important;}',
      'html body #sticky-atc .sticky-atc-title{grid-area:title!important;font-size:14px!important;line-height:1.2!important;font-weight:650!important;letter-spacing:0!important;color:#050609!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}',
      'html body #sticky-atc .sticky-atc-price{grid-area:price!important;font-size:14px!important;line-height:1!important;color:rgba(5,6,9,.64)!important;white-space:nowrap!important;margin:0!important;}',
      'html body #sticky-atc .sticky-atc-variant-row:not([data-sticky-variant-group]){display:none!important;}',
      'html body #sticky-atc .sticky-atc-variant-stack{grid-area:variants!important;display:grid!important;grid-template-columns:230px minmax(0,1fr)!important;grid-template-areas:"summary selector" ". fit"!important;align-items:center!important;column-gap:14px!important;row-gap:3px!important;min-width:0!important;margin:0!important;}',
      'html body #sticky-atc .sticky-atc-selected-summary{grid-area:summary!important;font-size:12px!important;line-height:1.2!important;color:rgba(5,6,9,.62)!important;white-space:nowrap!important;width:230px!important;min-width:0!important;max-width:230px!important;overflow:hidden!important;text-overflow:ellipsis!important;}',
      'html body #sticky-atc .sticky-atc-selector-group{grid-area:selector!important;display:flex!important;align-items:center!important;gap:8px!important;min-width:0!important;}',
      'html body #sticky-atc .sticky-atc-fit-note{grid-area:fit!important;margin:0!important;font-size:11px!important;line-height:1.2!important;color:rgba(5,6,9,.56)!important;white-space:nowrap!important;}',
      'html body #sticky-atc .sticky-atc-fit-note strong{font-weight:650!important;color:rgba(5,6,9,.72)!important;}',
      'html body #sticky-atc .sticky-atc-variant-row{display:flex!important;align-items:center!important;gap:8px!important;margin:0!important;min-width:0!important;flex:0 0 auto!important;}',
      'html body #sticky-atc .sticky-atc-variant{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;}',
      'html body #sticky-atc .sticky-atc-color-picker{display:flex!important;align-items:center!important;gap:8px!important;flex-wrap:nowrap!important;min-width:0!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch{position:relative;width:28px!important;height:28px!important;min-width:28px!important;padding:0!important;border:1px solid rgba(5,6,9,.18)!important;border-radius:6px!important;background:var(--bollide-sticky-swatch,#ccc)!important;cursor:pointer!important;box-shadow:inset 0 0 0 1px rgba(255,255,255,.7)!important;transition:border-color .16s ease,box-shadow .16s ease,transform .16s ease!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch:hover{border-color:rgba(5,6,9,.48)!important;transform:translateY(-1px)!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch.is-active{border-color:#050609!important;box-shadow:inset 0 0 0 3px #fff,0 0 0 1px #050609!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch:after{display:none!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch:focus-visible{outline:1px solid #050609!important;outline-offset:4px!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch[disabled]{opacity:.36;cursor:not-allowed;}',
      'html body #sticky-atc .sticky-atc-btn{height:46px!important;min-width:200px!important;padding:0 28px!important;border:1px solid #050609!important;border-radius:2px!important;background:#050609!important;color:#fff!important;font-family:acumin-pro,sans-serif!important;font-style:normal!important;font-size:12px!important;font-weight:400!important;line-height:1!important;letter-spacing:normal!important;text-transform:uppercase!important;box-shadow:none!important;transition:background .16s ease,color .16s ease,transform .16s ease!important;}',
      'html body #sticky-atc .sticky-atc-btn:hover{background:#927f57!important;border-color:#927f57!important;transform:translateY(-1px)!important;}',
      '@media(max-width:749px){html body #sticky-atc .sticky-atc-inner{min-height:78px!important;padding:8px 12px!important;gap:10px!important;}html body #sticky-atc .sticky-atc-left{grid-template-columns:42px minmax(0,1fr)!important;gap:10px!important;}html body #sticky-atc .sticky-atc-left img{width:42px!important;height:42px!important;border-radius:6px!important;}html body #sticky-atc .sticky-atc-left>div{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"title" "variants"!important;row-gap:4px!important;}html body #sticky-atc .sticky-atc-title{font-size:12px!important;}html body #sticky-atc .sticky-atc-price{display:none!important;}html body #sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"summary" "selector" "fit"!important;row-gap:2px!important;overflow:hidden!important;}html body #sticky-atc .sticky-atc-selected-summary{font-size:10.5px!important;width:auto!important;min-width:0!important;max-width:168px!important;overflow:hidden!important;text-overflow:ellipsis!important;}html body #sticky-atc .sticky-atc-selector-group{gap:6px!important;}html body #sticky-atc .sticky-atc-fit-note{font-size:10px!important;max-width:168px!important;overflow:hidden!important;text-overflow:ellipsis!important;}html body #sticky-atc .sticky-atc-color-picker{gap:6px!important;}html body #sticky-atc .sticky-atc-color-swatch{width:22px!important;height:22px!important;min-width:22px!important;border-radius:5px!important;}html body #sticky-atc .sticky-atc-btn{min-width:126px!important;height:42px!important;padding:0 14px!important;font-size:12px!important;}}'
    ].join('\n');
    style.textContent += '\n' + [
      'html body #sticky-atc .sticky-atc-inner{max-width:1180px!important;min-height:76px!important;padding:9px 24px!important;grid-template-columns:minmax(0,1fr) auto!important;gap:22px!important;}',
      'html body #sticky-atc .sticky-atc-left{grid-template-columns:52px minmax(0,1fr)!important;gap:14px!important;}',
      'html body #sticky-atc .sticky-atc-left img{width:52px!important;height:52px!important;border-radius:8px!important;}',
      'html body #sticky-atc .sticky-atc-left>div,html body #sticky-atc .sticky-atc-copy{grid-template-columns:minmax(170px,235px) minmax(260px,380px)!important;grid-template-areas:"title variants"!important;align-items:center!important;column-gap:36px!important;row-gap:0!important;}',
      'html body #sticky-atc .sticky-atc-title{font-size:14px!important;font-weight:650!important;}',
      'html body #sticky-atc .sticky-atc-action{display:flex!important;align-items:center!important;justify-content:flex-end!important;gap:18px!important;white-space:nowrap!important;}',
      'html body #sticky-atc .sticky-atc-price{display:block!important;font-size:14px!important;line-height:1!important;font-weight:400!important;color:rgba(5,6,9,.66)!important;margin:0!important;}',
      'html body #sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(96px,150px) auto!important;grid-template-areas:"summary selector" "fit selector"!important;align-items:center!important;column-gap:12px!important;row-gap:2px!important;}',
      'html body #sticky-atc .sticky-atc-selected-summary{font-size:13px!important;line-height:1.15!important;color:#050609!important;width:auto!important;max-width:150px!important;}',
      'html body #sticky-atc .sticky-atc-selector-group{gap:8px!important;}',
      'html body #sticky-atc .sticky-atc-fit-note{font-size:10.5px!important;line-height:1.15!important;color:rgba(5,6,9,.52)!important;max-width:150px!important;}',
      'html body #sticky-atc .sticky-atc-btn{min-width:184px!important;height:46px!important;padding:0 28px!important;}',
      '@media(max-width:749px){html body #sticky-atc .sticky-atc-inner{min-height:70px!important;padding:8px 10px!important;grid-template-columns:minmax(0,1fr) auto!important;gap:10px!important;}html body #sticky-atc .sticky-atc-left{grid-template-columns:40px minmax(0,1fr)!important;gap:10px!important;}html body #sticky-atc .sticky-atc-left img{width:40px!important;height:40px!important;border-radius:6px!important;}html body #sticky-atc .sticky-atc-left>div,html body #sticky-atc .sticky-atc-copy{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"title" "variants"!important;row-gap:3px!important;}html body #sticky-atc .sticky-atc-title{font-size:12px!important;}html body #sticky-atc .sticky-atc-action{gap:8px!important;}html body #sticky-atc .sticky-atc-price{display:block!important;font-size:12px!important;}html body #sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"summary" "fit"!important;row-gap:1px!important;}html body #sticky-atc .sticky-atc-selected-summary{font-size:10.5px!important;max-width:155px!important;}html body #sticky-atc .sticky-atc-selector-group{display:none!important;}html body #sticky-atc .sticky-atc-fit-note{font-size:10px!important;max-width:155px!important;}html body #sticky-atc .sticky-atc-btn{min-width:108px!important;height:40px!important;padding:0 12px!important;font-size:12px!important;}}'
    ].join('\n');
    style.textContent += '\n' + [
      'html body #sticky-atc .sticky-atc-color-picker{gap:8px!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch{width:28px!important;height:28px!important;min-width:28px!important;border:2px solid #331f19!important;border-radius:1px!important;background-color:var(--bollide-sticky-swatch,#ccc)!important;background-image:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2280%22 height=%2280%22 viewBox=%220 0 80 80%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%22.58%22 numOctaves=%224%22 seed=%2211%22/%3E%3CfeColorMatrix type=%22saturate%22 values=%220%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22 opacity=%22.55%22/%3E%3C/svg%3E")!important;background-blend-mode:soft-light!important;box-shadow:inset 0 0 0 3px #fbfaf7!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Alabaster"]{border-color:#331f19!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Forest"]{border-color:#756519!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Noir"]{border-color:#111!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Midnight"]{border-color:#1d3057!important;}',
      'html body #sticky-atc .sticky-atc-color-swatch.is-active{border-color:#050609!important;border-width:3px!important;box-shadow:inset 0 0 0 2px #fbfaf7!important;}',
      '@media(max-width:749px){html body #sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"selector"!important;row-gap:0!important;}html body #sticky-atc .sticky-atc-selected-summary,html body #sticky-atc .sticky-atc-fit-note{display:none!important;}html body #sticky-atc .sticky-atc-selector-group{display:flex!important;gap:6px!important;}html body #sticky-atc .sticky-atc-color-picker{gap:6px!important;}html body #sticky-atc .sticky-atc-color-swatch{width:22px!important;height:22px!important;min-width:22px!important;box-shadow:inset 0 0 0 2px #fbfaf7!important;}html body #sticky-atc .sticky-atc-color-swatch.is-active{box-shadow:inset 0 0 0 1px #fbfaf7!important;}}'
    ].join('\n');
    style.textContent += '\n' + [
      'html body #sticky-atc .sticky-atc-color-swatch.is-coming-soon:after{display:block!important;content:""!important;position:absolute!important;left:5px!important;right:5px!important;top:50%!important;height:1px!important;background:rgba(255,255,255,.92)!important;box-shadow:0 0 0 1px rgba(5,6,9,.22)!important;transform:rotate(-38deg)!important;pointer-events:none!important;}',
      'html body #sticky-atc .sticky-atc-btn:disabled,html body #sticky-atc .sticky-atc-btn.is-coming-soon{background:#d8d5cf!important;border-color:#d8d5cf!important;color:rgba(51,31,25,.7)!important;cursor:not-allowed!important;transform:none!important;opacity:1!important;}',
      '@media(max-width:767px){html body #sticky-atc .sticky-atc-selector-group{display:block!important;overflow-x:auto!important;overflow-y:hidden!important;overscroll-behavior-x:contain!important;scrollbar-width:none!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-x!important;}html body #sticky-atc .sticky-atc-selector-group::-webkit-scrollbar{display:none!important;}html body #sticky-atc .sticky-atc-color-picker{display:flex!important;flex-wrap:nowrap!important;width:max-content!important;min-width:176px!important;height:44px!important;gap:0!important;}html body #sticky-atc .sticky-atc-color-swatch{flex:0 0 44px!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function stickyRoot() { return document.getElementById('sticky-atc'); }

  function markStickyRoot() {
    var root = stickyRoot();
    if (root) root.classList.add('bollide-sticky-atc-premium');
  }

  function stickyInfoContainer() {
    var root = stickyRoot();
    if (!root) return null;
    return root.querySelector('.sticky-atc-copy') || root.querySelector('.sticky-atc-left > div') || root.querySelector('.sticky-atc-left');
  }

  function swatchColor(color) {
    return swatchColors[key(color)] || '#cccccc';
  }

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('variant')) return params.get('variant');
    } catch (error) {}
    return config.selectedVariantId;
  }

  function selectedColor() {
    var label = document.getElementById('selected-color');
    if (label && normalize(label.textContent)) return normalize(label.textContent);

    var checked = document.querySelector('input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="color"]:checked, [data-single-option-selector]:checked');
    if (checked && normalize(checked.value || checked.getAttribute('data-value'))) {
      return normalize(checked.value || checked.getAttribute('data-value'));
    }

    var variant = variantById(currentVariantId());
    return variant ? colorFromVariant(variant) : '';
  }

  function buildRows() {
    injectStyles();
    markStickyRoot();

    var container = stickyInfoContainer();
    if (!container) return;

    var groups = groupedColors();
    var signature = rowOrder.map(function (row) {
      return row.key + ':' + (groups[row.key] || []).map(key).join(',');
    }).join('|');

    var stack = document.getElementById('sticky-atc-variant-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.id = 'sticky-atc-variant-stack';
      stack.className = 'sticky-atc-variant-stack';
      container.appendChild(stack);
    }

    if (stack.getAttribute('data-bollide-signature') === signature && stack.children.length) {
      var currentFitNote = stack.querySelector('.sticky-atc-fit-note');
      if (currentFitNote && FIT_NOTE_TEXT) currentFitNote.textContent = FIT_NOTE_TEXT;
      return;
    }

    stack.innerHTML = '';
    stack.setAttribute('data-bollide-signature', signature);

    var summary = document.createElement('div');
    summary.id = 'sticky-atc-selected-summary';
    summary.className = 'sticky-atc-selected-summary';
    summary.setAttribute('aria-live', 'polite');
    stack.appendChild(summary);

    var selectorGroup = document.createElement('div');
    selectorGroup.className = 'sticky-atc-selector-group';
    stack.appendChild(selectorGroup);

    rowOrder.forEach(function (rowDef) {
      var colors = groups[rowDef.key] || [];
      if (!colors.length) return;

      var row = document.createElement('div');
      var label = document.createElement('div');
      var picker = document.createElement('div');

      row.className = 'sticky-atc-variant-row sticky-atc-variant-row--' + rowDef.key;
      row.setAttribute('data-sticky-variant-group', rowDef.key);
      label.className = 'sticky-atc-variant';
      label.textContent = rowDef.label;
      picker.className = 'sticky-atc-color-picker';
      picker.setAttribute('role', 'radiogroup');
      picker.setAttribute('aria-label', rowDef.label + ' variants');

      row.appendChild(label);
      row.appendChild(picker);

      colors.forEach(function (color) {
        var variant = variantByColor(color);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sticky-atc-color-swatch';
        button.setAttribute('data-sticky-color', color);
        button.setAttribute('data-sticky-group', rowDef.key);
        button.setAttribute('aria-label', 'Select ' + color);
        button.setAttribute('aria-pressed', 'false');
        button.title = color;
        button.style.setProperty('--bollide-sticky-swatch', swatchColor(color));

        if (variant && variant.available === false) {
          button.classList.add('is-coming-soon');
          button.setAttribute('aria-label', color + ', coming soon');
          button.title = color + ' - Coming soon';
        }

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          selectStickyColor(color);
        });

        picker.appendChild(button);
      });

      selectorGroup.appendChild(row);
    });

    if (shouldShowFitNote() && FIT_NOTE_TEXT) {
      var fitNote = document.createElement('div');
      fitNote.className = 'sticky-atc-fit-note';
      fitNote.textContent = FIT_NOTE_TEXT;
      stack.appendChild(fitNote);
    }
  }

  function updateSelectedSummary(color) {
    var summary = document.getElementById('sticky-atc-selected-summary');
    color = normalize(color);
    if (!summary || !color) return;
    summary.textContent = displayColor(color);
  }

  function revealActiveSwatch(button) {
    if (!button || !button.closest) return;
    var scroller = button.closest('.sticky-atc-selector-group');
    if (!scroller || scroller.clientWidth <= 0) return;

    function reveal() {
      var scrollerRect = scroller.getBoundingClientRect();
      var buttonRect = button.getBoundingClientRect();
      var next = scroller.scrollLeft;

      if (buttonRect.left < scrollerRect.left) {
        next -= scrollerRect.left - buttonRect.left;
      } else if (buttonRect.right > scrollerRect.right) {
        next += buttonRect.right - scrollerRect.right;
      }

      var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      next = Math.max(0, Math.min(next, max));
      if (Math.abs(next - scroller.scrollLeft) < 1) return;
      if (typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({ left: next, behavior: 'auto' });
      } else {
        scroller.scrollLeft = next;
      }
    }

    reveal();
  }

  function queueActiveSwatchReveal() {
    if (!window.requestAnimationFrame) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        revealActiveSwatch(document.querySelector('#sticky-atc-variant-stack .sticky-atc-color-swatch.is-active'));
      });
    });
  }

  function setActive(color) {
    document.querySelectorAll('#sticky-atc-variant-stack [data-sticky-color]').forEach(function (button) {
      var active = key(button.getAttribute('data-sticky-color')) === key(color);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) queueActiveSwatchReveal();
    });
  }

  function setVariantInputs(variant) {
    if (!variant || !variant.id) return;
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (input) {
      if (String(input.value) === String(variant.id)) return;
      input.value = variant.id;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function syncStickySellingPlan(variant) {
    var form = document.querySelector('#sticky-atc form[action*="/cart/add"]');
    if (!form) return;

    var input = form.querySelector('input[name="selling_plan"]');
    var planId = variant && variant.sellingPlanId;

    if (!planId) {
      if (input) input.remove();
      return;
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.setAttribute('data-sticky-selling-plan', '');
      form.appendChild(input);
    }

    input.value = String(planId);
  }

  function syncMainControl(color) {
    var target = key(color);
    var controls = Array.prototype.slice.call(document.querySelectorAll('input[type="radio"], [data-single-option-selector], .color-swatch, [data-color]'));

    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      if (control.closest && control.closest('#sticky-atc')) continue;

      var value = normalize(control.value || control.getAttribute('data-color') || control.getAttribute('data-value') || control.getAttribute('aria-label') || control.textContent);
      if (key(value) !== target) continue;

      if (control.tagName === 'INPUT') {
        control.checked = true;
        control.dispatchEvent(new Event('input', { bubbles: true }));
        control.dispatchEvent(new Event('change', { bubbles: true }));
        var label = control.id ? document.querySelector('label[for="' + control.id + '"]') : null;
        if (label && !(label.closest && label.closest('#sticky-atc'))) label.click();
        else control.click();
      } else {
        control.click();
      }
      return true;
    }
    return false;
  }

  function updateStickyImage(variant) {
    var root = stickyRoot();
    var img = root ? root.querySelector('.sticky-atc-left img, img') : null;
    if (!img || !variant || !variant.image) return;

    var color = key(colorFromVariant(variant));
    var galleryImages = Array.prototype.slice.call(
      document.querySelectorAll('[data-product-single-media-group] img')
    ).filter(function (candidate) {
      var src = candidate.currentSrc || candidate.src || '';
      return src && src.indexOf('-catalog') === -1;
    });
    var matchingImage = galleryImages.find(function (candidate) {
      var src = key(candidate.currentSrc || candidate.src || '');
      var alt = key(candidate.alt || '');
      return color && (src.indexOf(color) !== -1 || alt.indexOf(color) !== -1);
    });
    var storefrontImage = matchingImage || galleryImages[0];

    img.src = storefrontImage ? (storefrontImage.currentSrc || storefrontImage.src) : variant.image;
    img.removeAttribute('srcset');
    img.alt = (config.productTitle || 'BOLLIDE Silk-Lined Hat') + ' - ' + colorFromVariant(variant);
  }

  function updateStickyCta(variant) {
    var root = stickyRoot();
    var button = root && root.querySelector('#sticky-atc-btn, .sticky-atc-btn');
    if (!button) return;

    variant = variant || variantById(currentVariantId());
    var available = !!(variant && variant.available !== false);
    var text = button.querySelector('[data-add-to-cart-text]') || button;

    button.disabled = !available;
    button.classList.toggle('is-coming-soon', !available);
    button.setAttribute('aria-disabled', available ? 'false' : 'true');
    var preorderText = 'Preorder — ' + (variant && variant.priceText ? variant.priceText : '$350');
    text.textContent = available ? (variant && variant.isPreorder ? preorderText : CTA_TEXT) : COMING_SOON_TEXT;
  }

  function updateStickyDisplay(color, variant) {
    buildRows();
    color = normalize(color || selectedColor());
    variant = variant || variantByColor(color) || variantById(currentVariantId());
    if (!color && variant) color = colorFromVariant(variant);
    if (!color) return;
    if (variant) {
      setVariantInputs(variant);
      syncStickySellingPlan(variant);
    }
    updateSelectedSummary(color);
    setActive(color);
    updateStickyImage(variant);
    updateStickyCta(variant);
  }

  function selectStickyColor(color) {
    var variant = variantByColor(color);
    if (!variant) return;
    updateUrl(variant.id);
    updateStickyDisplay(color, variant);
    setVariantInputs(variant);
    if (!syncMainControl(color)) {
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
      } catch (error) {}
    }
    setTimeout(function () { updateStickyDisplay(color, variant); }, 120);
    setTimeout(function () { updateStickyImage(variant); }, 350);
    setTimeout(function () { updateStickyCta(variant); }, 700);
  }

  function updateUrl(variantId) {
    if (!variantId || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (error) {}
  }

  function scheduleUpdate() {
    setTimeout(function () { updateStickyDisplay(); }, 60);
    setTimeout(function () { updateStickyDisplay(); }, 260);
    setTimeout(function () { updateStickyCta(); }, 600);
  }

  function handleVariantChange(event) {
    var variant = event && event.detail ? event.detail.variant : null;
    if (variant) setVariantInputs(variant);
    updateStickyDisplay(variant ? colorFromVariant(variant) : '', variant);
  }

  function init() {
    buildRows();
    updateStickyDisplay();
    updateStickyCta();
    setTimeout(injectStyles, 500);

    var root = stickyRoot();
    if (root && window.MutationObserver) {
      var stickyWasVisible = root.getAttribute('aria-hidden') === 'false';
      new MutationObserver(function () {
        var stickyIsVisible = root.getAttribute('aria-hidden') === 'false';
        if (stickyIsVisible && !stickyWasVisible) queueActiveSwatchReveal();
        stickyWasVisible = stickyIsVisible;
      }).observe(root, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    window.addEventListener('resize', queueActiveSwatchReveal);

    document.addEventListener('variant:change', handleVariantChange, true);
    document.addEventListener('theme:variant:change', handleVariantChange, true);
    document.addEventListener('bollide:performance-variant-change', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var variant = variantById(detail.variantId) || variantByColor(detail.color);
      if (variant) updateStickyDisplay(colorFromVariant(variant), variant);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('#sticky-atc')) return;
      var input = form.querySelector('[name="id"]');
      var variant = variantById(input && input.value);
      if (!variant || variant.available !== false) return;
      event.preventDefault();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      updateStickyCta(variant);
    }, true);

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches('input[name="id"], select[name="id"], [data-single-option-selector], input[type="radio"][name*="Color"], input[type="radio"][name*="color"]')) {
        scheduleUpdate();
      }
    }, true);

    document.addEventListener('click', function (event) {
      var swatch = event.target && event.target.closest ? event.target.closest('.color-swatch, [data-color]') : null;
      if (swatch && !(swatch.closest && swatch.closest('#sticky-atc'))) scheduleUpdate();
    }, true);

    window.addEventListener('load', scheduleUpdate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
